import FetchWrapper from '../../functions/fetchWrapper'

export { loginUser, logoutUser } from './auth'

export const API  = () => FetchWrapper.getInstance('auth')
